// components/MobileNavigation/DefaultSection.tsx
import React from 'react';
import NavItemLink from './NavItemLink';

interface DefaultSectionProps {
  sections: any[];
  activeItem: string;
  onNavClick: (itemId: string) => void;
}

const DefaultSection: React.FC<DefaultSectionProps> = ({ sections, activeItem, onNavClick }) => {
  return (
    <div className="space-y-4">
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex}>
          {section.title && (
            <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2 px-1">
              {section.title}
            </h4>
          )}
          <div className="space-y-1">
            {section.items.map((subItem : any) => (
              <NavItemLink
                key={subItem.id}
                item={subItem}
                activeItem={activeItem}
                onNavClick={onNavClick}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DefaultSection;